import React, { createContext, useContext, useState, useMemo } from 'react'
import {
  DisplayContextProps,
  DisplayContextDefaultValues,
} from '@Interfaces/Context/DisplayInterface'
import { ContextComponentProps } from '@Interfaces/Util/CommonInterface'

export const DisplayContext = createContext<DisplayContextProps>(DisplayContextDefaultValues)

export const DisplayProvider = ({ children }: ContextComponentProps) => {
  const [showSidebar, setShowSidebar] = useState(true)

  const contextValue = useMemo(
    () => ({
      showSidebar,
      setShowSidebar,
    }),
    [showSidebar]
  )

  return <DisplayContext.Provider value={contextValue}>{children}</DisplayContext.Provider>
}

export const useDisplay = (): DisplayContextProps => useContext(DisplayContext)
